import styled from "styled-components";
import { colors } from "../../theme/colors";
import { BarChart } from "@mui/icons-material";
import { Typography, Grid, Button } from "@mui/material";

export const StyledContentWrapper = styled.div`
  width: 90%;
  margin: 2rem auto;
`;

export const StyledTitleWrapper = styled.div`
  background-color: ${colors.secondary};
  display: flex;
  flex-direction: column;
  height: 113px;
  justify-content: center;
  padding-left: 5%;
`;

export const StyledMainContainer = styled.div`
  background-color: ${(props) => (props.white ? "#ffffff" : "#003865")};
  min-height: 100vh;
  max-width: 1366px;
  margin: 0 auto;
  padding: 96px 32px;
  display: flex;
  gap: 5rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 0rem;
    gap: 1rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0rem 0rem 3rem 0rem;
    gap: 1rem;
  }
`;

export const StyledStatsCard = styled.div`
  background-color: #ffffff;
  border-radius: 64px 0px 64px 0px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  min-width: 450px;
  height: fit-content;

  @media (max-width: 1024px) {
    margin: 0rem 0rem 3rem 0rem;
    max-width: 100%;
    min-width: 100%;
    padding: 1.5rem;
    border-radius: 0px 0px 80px 80px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 1.5rem;
    border-radius: 0px 0px 80px 80px;
  }
`;

export const StyledCircleChart = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: conic-gradient(
    #003865 0deg 180deg,
    #4fc3d7 180deg 270deg,
    #ffd15c 270deg 360deg
  );
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;

  &::before {
    content: "";
    position: absolute;
    width: 120px;
    height: 120px;
    background-color: white;
    border-radius: 50%;
  }

  @media (max-width: 768px) {
    width: 150px;
    height: 150px;

    &::before {
      width: 90px;
      height: 90px;
    }
  }
`;

export const StyledChartIcon = styled(BarChart)`
  && {
    font-size: 48px;
    color: #003865;
    z-index: 1;

    @media (max-width: 768px) {
      font-size: 36px;
    }
  }
`;

export const StyledRightPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  flex: 1;

  @media (max-width: 1024px) {
    padding: 0px 36px;
  }

  @media (max-width: 768px) {
    padding: 0px 36px;
  }
`;

export const StyledRetosHeader = styled.div`
  background-color: ${colors.orange.title};
  border-radius: 32px 0px 32px 0px;
  padding: 0.5rem 2rem;
  text-align: center;
  max-width: 250px;
  margin-bottom: 1rem;
  margin-left: 3rem;

  @media (max-width: 1024px) {
    margin: 0 auto 1.5rem auto;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    margin-left: 0rem;
    padding: 0.8rem 1.5rem;
  }
`;

export const StyledRetoCard = styled.div`
  background-color: ${colors.white.main};
  border-radius: ${(props) => (props.month ? "16px" : "32px 0px 32px 0px")};
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 3px 6px #00000029;
  cursor: pointer;
  transition: transform 0.2s ease;
  pointer-events: auto;
  position: relative;
  min-height: ${(props) => (props.month ? "auto" : "142px")};

  &:hover {
    transform: translateY(-2px);
  }

  .reto-content {
    display: flex;
    align-items: center;
    flex: 1;
    pointer-events: auto;
  }

  .reto-text {
    flex: 1;
    margin-left: 1rem;
    pointer-events: auto;
  }

  .reto-title {
    color: ${(props) =>
      props.completed ? "#003865 !important" : "#003865 !important"};
    font-weight: 700 !important;
    margin-bottom: 0.5rem !important;
    font-size: 1rem !important;
    pointer-events: auto;
  }

  .stars-container {
    display: flex;
    gap: 2px;
    align-items: center;
  }

  .arrow-icon {
    color: ${(props) => (props.completed ? "#003865" : "#003865")};
    margin-left: 1rem;
    cursor: pointer;
    pointer-events: auto;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  @media (max-width: 768px) {
    padding: 1rem;
    min-height: ${(props) => (props.month ? "80px" : "180px")};
    margin-bottom: 0.5rem;
    max-width: 360px;

    .reto-text {
      margin-left: 0.8rem;
    }

    .reto-title {
      font-size: 0.9rem !important;
    }
  }
`;

export const StyledLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 1rem;

  @media (max-width: 768px) {
    gap: 1rem;
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #666;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export const StyledLegendDot = styled.div`
  width: 23px;
  height: 23px;
  border-radius: 8px 0px 8px 0px;
  background-color: ${(props) => props.color};
  flex-shrink: 0;
`;

export const StyledFloatingButton = styled.div`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 80px;
  height: 80px;
  background-color: #4fc3d7;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  .icon {
    color: #ffffff;
    font-size: 36px;
  }

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    bottom: 1rem;
    right: 1rem;

    .icon {
      font-size: 28px;
    }
  }
`;

export const StyledRecompensaCard = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const StyledPendienteItem = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const StyledRecompensasContainer = styled.div`
  background-color: #003865;
  min-height: 100vh;
  padding: 2rem 3rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const StyledMonthHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: white;
  margin-bottom: 2rem;

  .month-icon {
    font-size: 2rem;
  }

  h4 {
    font-weight: bold;
    margin: 0;
  }
`;

export const StyledBottomNav = styled.div`
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.5rem;
  background-color: white;
  border-radius: 12px;
  padding: 0.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    bottom: 1rem;
  }
`;

export const StyledMainContainerLanding = styled.div`
  background-color: ${(props) => (props.white ? "#ffffff" : "#003865")};
  min-height: 50vh;
  max-width: 1366px;
  margin: 0 auto;
  padding: 0px 32px;
  display: flex;
  gap: 5rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 0rem;
    gap: 1rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0rem 0rem 0rem 0rem;
    gap: 1rem;
  }
`;

export const StyledBeneficioCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 0;
  height: 100%;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
  }

  .image-container {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem 1rem 1rem;
    background: white;

    img {
      width: 100%;
      max-width: 200px;
      height: 209px;
      object-fit: contain;
      filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    }
  }

  .content-container {
    background: white;
    padding: 1.5rem;
    border-radius: 0 0 20px 20px;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .benefit-title {
    color: ${colors.primary} !important;
    font-weight: 700 !important;
    font-size: 1.1rem !important;
    line-height: 1.3 !important;
    margin: 0 !important;
  }

  .benefit-description {
    color: #666 !important;
    font-size: 0.9rem !important;
    line-height: 1.4 !important;
    margin: 0 !important;
    flex: 1;
  }

  @media (max-width: 1200px) {
    min-height: 320px;

    .image-container {
      height: 180px;
      padding: 1.5rem 1rem 0.8rem 1rem;

      img {
        max-width: 160px;
      }
    }

    .content-container {
      min-height: 110px;
      padding: 1.2rem;
    }

    .benefit-title {
      font-size: 1rem !important;
    }

    .benefit-description {
      font-size: 0.85rem !important;
    }
  }

  @media (max-width: 768px) {
    min-height: 300px;

    .image-container {
      height: 160px;
      padding: 1.2rem 1rem 0.5rem 1rem;

      img {
        max-width: 140px;
      }
    }

    .content-container {
      min-height: 100px;
      padding: 1rem;
    }

    .benefit-title {
      font-size: 0.95rem !important;
    }

    .benefit-description {
      font-size: 0.8rem !important;
    }
  }

  @media (max-width: 480px) {
    min-height: 280px;

    .image-container {
      height: 140px;
      padding: 1rem 0.8rem 0.3rem 0.8rem;

      img {
        max-width: 120px;
      }
    }

    .content-container {
      padding: 0.8rem;
    }
  }
`;

export const StyledAlfabetizacionSection = styled.div`
  background-color: white;
  padding: 4rem 2rem;
  text-align: center;

  .section-title {
    color: ${colors.primary} !important;
    font-weight: bold !important;
    margin-bottom: 3rem !important;
    font-size: 1.8rem !important;
  }

  .images-container {
    padding-top: 5rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 0;
    margin-bottom: -3rem;
    height: 400px;
    position: relative;

    @media (max-width: 768px) {
      padding-top: 0rem;
      flex-direction: column;
      height: auto;
      gap: 1rem;
      align-items: center;
    }
  }

  .blog-info {
    color: ${colors.secondary} !important;
    margin-top: -6rem !important;
    margin-bottom: 2rem !important;
    font-size: 1.1rem !important;
  }

  @media (max-width: 768px) {
    padding: 2rem 1rem;

    .section-title {
      font-size: 2rem !important;
    }

    .blog-info {
      margin-top: 2rem !important;
    }
  }
`;

export const StyledImageCard = styled.div`
  position: relative;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: bottom;

  &.side-image {
    width: 230px;
    z-index: 1;

    img {
      width: 250px;
      height: auto;
    }

    .image-text {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      background: transparent;
      padding: 0.8rem 1.2rem;
      border-radius: 8px;
      box-shadow: none;
      font-weight: 600;
      color: ${colors.primary};
      font-size: 0.9rem;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 10;
    }

    &:hover {
      transform: translateY(-20px);
      z-index: 5;

      .image-text {
        opacity: 1;
        visibility: visible;
        transform: translateX(-50%) translateY(0);
      }
    }
  }

  &.center-image {
    width: 280px;
    z-index: 2;
    margin: -60px -20px;

    img {
      width: 280px;
      height: auto;
    }

    .image-text {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      background: transparent;
      padding: 1rem 1.5rem;
      border-radius: 8px;
      box-shadow: none;
      font-weight: 600;
      color: ${colors.primary};
      font-size: 1rem;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 10;
    }

    &:hover {
      transform: translateY(-20px);
      z-index: 5;

      .image-text {
        opacity: 1;
        visibility: visible;
        transform: translateX(-50%) translateY(0);
      }
    }
  }

  @media (max-width: 768px) {
    &.side-image,
    &.center-image {
      width: 250px;
      margin: 0;

      img {
        width: 250px;
      }

      .image-text {
        position: static;
        transform: none;
        margin-top: 1rem;
        opacity: 1;
        visibility: visible;
        display: inline-block;
      }

      &:hover {
        transform: none;

        .image-text {
          transform: none;
        }
      }
    }
  }
`;

export const StyledBlogButton = styled(Button)`
  && {
    background-color: ${colors.secondary};
    color: ${colors.primary};
    border-radius: 8px;
    padding: 0.8rem 2.5rem;
    text-transform: none;
    font-weight: bold;
    font-size: 1rem;
    transition: all 0.3s ease;

    &:hover {
      background-color: #38a8bb;
      transform: translateY(-2px);
    }
  }
`;

export const StyledAlfabetizacionContainer = styled.div`
  padding: 2rem;
  width: 100%;
  padding-top: 4rem;

  @media (max-width: 768px) {
    padding: 1rem;
    padding-top: 0rem;
  }
`;

export const StyledHeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 3rem;
  width: 100%;

  .header-content {
    flex: 1;
    max-width: 600px;
  }

  .main-title {
    color: ${colors.orange.title} !important;
    font-weight: 700 !important;
    font-size: 28px !important;
    margin-bottom: 1.5rem !important;
    line-height: 1.2 !important;
  }

  .main-description {
    color: ${colors.white.main} !important;
    font-size: 1rem !important;
    line-height: 1.6 !important;
  }

  .main-subtitle {
    color: white !important;
    font-size: 1rem !important;
    line-height: 1.6 !important;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: left;
    align-items: flex-start;
    gap: 2rem;
    padding: 2rem 1rem;

    .main-title {
      font-size: 2rem !important;
    }

    .main-description,
    .main-subtitle {
      font-size: 1rem !important;
    }
  }
`;

export const StyledCreditCard = styled.div`
  flex-shrink: 0;
  transition: transform 0.3s ease;

  &:hover {
    transform: rotate(0deg) scale(1.05);
  }

  img {
    width: 280px;
    height: auto;
  }

  @media (max-width: 768px) {
    img {
      width: 220px;
    }
  }
`;

export const StyledAlfabetizacionCard = styled.div`
  background: transparent;
  border-radius: 32px;
  border: 2px solid ${(props) => props.borderColor || colors.orange.light};
  width: 100%;
  max-width: 320px;
  height: 500px;
  overflow: visible;
  transition: all 0.3s ease;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.isCenter &&
    `
    transform: scale(1.05);
    z-index: 2;
    
    @media (max-width: 768px) {
      transform: scale(1);
    }
  `}

  &:hover {
    transform: translateY(-10px)
      ${(props) => (props.isCenter ? "scale(1.1)" : "scale(1.02)")};
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    max-width: 100%;
    height: 480px;
    margin: 0 auto 2rem auto;
  }
`;

export const StyledCardImage = styled.div`
  position: relative;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
  overflow: visible;
  margin: -20px -20px 0 -20px;

  img {
    width: 80%;
    height: 280px;
    object-fit: contain;
    border-radius: 0px;
    top: -15px;
    left: 10px;

    position: relative;
    z-index: 1;
  }

  @media (max-width: 768px) {
    height: 240px;
    margin: -15px -15px 0 -15px;

    img {
      width: 100%;
      height: 215px;
      top: -10px;
      left: 12px;
    }
  }
`;

export const StyledCardContent = styled.div`
  padding: 0rem 1.5rem 1.5rem 1.5rem;
  border-radius: 32px !important;
  text-align: center;
  background: white;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #003865;

  .card-title {
    color: ${colors.white.main} !important;
    font-weight: 700 !important;
    font-size: 1.3rem !important;
    margin-bottom: 1rem !important;
    line-height: 1.3 !important;
  }

  .card-description {
    color: ${colors.white.main} !important;
    font-size: 0.95rem !important;
    line-height: 1.5 !important;
    margin-bottom: 0rem !important;
    text-align: center;
    flex: 1;
  }

  .highlight-text {
    color: ${colors.white.main} !important;
    font-weight: 700 !important;
  }

  @media (max-width: 768px) {
    padding: 1.2rem;

    .card-title {
      font-size: 1.1rem !important;
    }

    .card-description {
      font-size: 0.9rem !important;
      margin-bottom: 1.2rem !important;
    }
  }
`;

export const StyledKnowMoreButton = styled.button`
  background-color: ${colors.secondary};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.8rem 2rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #38a8bb;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 0.7rem 1.5rem;
    font-size: 0.9rem;
  }
`;

export const PrincipalContainerHome = styled.div`
  min-height: 100vh;

  @media (max-width: 1024px) {
    min-height: 70vh !important;
  }

  @media (max-width: 768px) {
    min-height: max-content;
  }
`;
